import type { App } from 'vue';

import InfoNotification from '../components/Layout/InfoNotification.vue';

const components = {
  InfoNotification,
};

export interface ExtensionLibraryComponents {
  InfoNotification: typeof InfoNotification;
}

export const useLibrary = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component);
  }
};
